import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const useCartStore = create(
  persist(
    (set, get) => ({
      items: [],
      
      addItem: (product, variant = null, quantity = 1) => {
        const items = get().items
        const existingItemIndex = items.findIndex(
          (item) => item.productId === product.id && item.variantId === (variant?.id || null)
        )

        if (existingItemIndex >= 0) {
          // Увеличиваем количество существующего товара
          const updatedItems = [...items]
          updatedItems[existingItemIndex].quantity += quantity
          set({ items: updatedItems })
        } else {
          // Добавляем новый товар
          const price = variant ? variant.final_price : product.price
          const mainImage = product.images?.find((img) => img.is_main) || product.images?.[0]
          
          set({
            items: [
              ...items,
              {
                id: Date.now(),
                productId: product.id,
                productName: product.name,
                productImage: mainImage?.image || '',
                variantId: variant?.id || null,
                variantSize: variant?.size || null,
                variantColor: variant?.color || null,
                price: parseFloat(price),
                quantity: quantity,
              },
            ],
          })
        }
      },

      removeItem: (itemId) => {
        set({ items: get().items.filter((item) => item.id !== itemId) })
      },

      updateQuantity: (itemId, quantity) => {
        if (quantity <= 0) {
          get().removeItem(itemId)
          return
        }
        const items = get().items.map((item) =>
          item.id === itemId ? { ...item, quantity } : item
        )
        set({ items })
      },

      clearCart: () => {
        set({ items: [] })
      },

      getTotalItems: () => {
        return get().items.reduce((total, item) => total + item.quantity, 0)
      },

      getTotalPrice: () => {
        return get().items.reduce(
          (total, item) => total + item.price * item.quantity,
          0
        )
      },
    }),
    {
      name: 'crysquad-cart-storage',
    }
  )
)

export { useCartStore }
